import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-header mb-0" }, "Meu plano")
], -1)
const _hoisted_3 = {
  key: 1,
  class: "card-body"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text-paragraph" }, " Aqui você irá encontrar as informações referentes a assinatura do Psiapp. ", -1)
const _hoisted_5 = { class: "list-group list-group-flush" }
const _hoisted_6 = { class: "text-paragraph" }
const _hoisted_7 = {
  key: 0,
  class: "d-flex justify-content-center align-items-center"
}
const _hoisted_8 = { class: "text-danger text-subtitle my-8" }
const _hoisted_9 = {
  key: 0,
  class: "card"
}
const _hoisted_10 = { class: "card-body" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "text-header" }, "Precisa cancelar a assinatura?", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", { class: "text-paragraph" }, " Caso você não queira mais ser um membro do Psiapp Mais e deseja perder todos os benefícios, você pode cancelar sua assinatura clicando abaixo: ", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "text-paragraph" }, " É uma pena saber que você gostaria de cancelar sua assinatura. ", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "text-paragraph text-danger" }, " Cancelando sua assinatura você não terá mais acesso ao aplicativo. ", -1)

import Button from "@/components/Button.vue";
import router from "@/router";
import paths from "@/router/paths";
import { subsService } from "@/services";
import { useMainStore } from "@/store";
import { syncSessionUseCase } from "@/useCases";
import { EventBus, EventBusNames } from "@/utils/EventBus";
import { toggleModal } from "@/utils/Helper";
import {
  EOffcanvasViews,
  navigateCanvas,
  OffcanvasViewKey,
} from "@/views/OffcanvasViews/OffcanvasViewsConfig";
import PsiappPlusCard from "@/views/PsiappPlus/PsiappPlusCard.vue";
import { useMutation, useQuery } from "@tanstack/vue-query";
import { computed, onMounted } from "vue";
import { useRoute } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'MyPlan',
  setup(__props) {

onMounted(() => {
  EventBus.$on(EventBusNames.REFRESH_MY_PLAN, () => refetch());
});

const { session } = useMainStore();

const subsId = computed<number>(() => {
  if (session && session.subscription) return session.subscription.id;
  return 0;
});

const route = useRoute();

const toggle = computed<boolean>(() => {
  return window.innerWidth > 964;
});

const { isLoading, refetch, data, error } = useQuery({
  queryFn: () => subsService.showSubs(subsId.value),
  queryKey: ["show_subs"],
});

const { mutateAsync: handleCancel, isPending: canceling } = useMutation({
  mutationFn: () => subsService.cancelSubs(subsId.value),
  onSuccess: async () => {
    toggleModal("cancel_subs");

    await syncSessionUseCase.execute();

    EventBus.$emit(EventBusNames.SHOW_TOAST, {
      title: "Assinatura cancelada",
      msg: `Sua assinatura ${data.value?.plan_title} foi cancelada com sucesso.`,
    });
    EventBus.$emit(EventBusNames.ON_HOLDING_UPDATE);

    refetch();
  },
  onError: (error) => {
    console.error(error);
  },
});

const { mutateAsync: handleManualPay, isPending: manualPaying } = useMutation({
  mutationFn: () => subsService.manualPaymentSubs(subsId.value),
  onSuccess: async () => {
    await syncSessionUseCase.execute();
    refetch();
    EventBus.$emit(EventBusNames.ON_HOLDING_UPDATE);
  },
  onError: (error) => {
    alert(error.message);
  },
});

const { mutateAsync: handleReactivate, isPending: reactivating } = useMutation({
  mutationFn: () => subsService.reactivateSubs(subsId.value),
  onSuccess: async () => {
    await syncSessionUseCase.execute();
    refetch();
    EventBus.$emit(EventBusNames.ON_HOLDING_UPDATE);
  },
  onError: (error) => {
    console.error(error);
  },
});

const handleCreditCards = () => {
  EventBus.$emit(EventBusNames.GET_CREDIT_CARDS);
  navigateCanvas(
    EOffcanvasViews.credit_cards as OffcanvasViewKey,
    null,
    toggle.value,
  );
};

const onCancel = () => toggleModal("cancel_subs");

return (_ctx: any,_cache: any) => {
  const _component_LoadingContainer = _resolveComponent("LoadingContainer")!
  const _component_ModalComponent = _resolveComponent("ModalComponent")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      (_unref(isLoading))
        ? (_openBlock(), _createBlock(_component_LoadingContainer, { key: 0 }))
        : (_unref(data))
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _hoisted_4,
              (_unref(data).subscribe_enabled)
                ? (_openBlock(), _createBlock(PsiappPlusCard, { key: 0 }))
                : _createCommentVNode("", true),
              _createElementVNode("ul", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).items, (item) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: item.key,
                    class: "list-group-item px-0"
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["d-flex justify-content-between", { 'mb-3': item.description }])
                    }, [
                      _createElementVNode("span", _hoisted_6, _toDisplayString(item.label), 1),
                      _createElementVNode("span", {
                        class: _normalizeClass(["text-subtitle", `text-${item.value.color}`])
                      }, _toDisplayString(item.value.text), 3)
                    ], 2),
                    (item.description)
                      ? (_openBlock(), _createElementBlock("p", {
                          key: 0,
                          class: _normalizeClass(["text-paragraph mb-2", `text-${item.value.color}`])
                        }, _toDisplayString(item.description.text), 3))
                      : _createCommentVNode("", true),
                    (_unref(data).manual_payment_enabled && item.key === 'status')
                      ? (_openBlock(), _createBlock(Button, {
                          key: 1,
                          onOnClick: _unref(handleManualPay),
                          loading: _unref(manualPaying),
                          fullWidth: "",
                          label: "Tentar realizar pagamento novamente"
                        }, null, 8, ["onOnClick", "loading"]))
                      : _createCommentVNode("", true),
                    (_unref(data).has_canceled && item.key === 'status')
                      ? (_openBlock(), _createBlock(Button, {
                          key: 2,
                          onOnClick: _unref(handleReactivate),
                          loading: _unref(reactivating),
                          fullWidth: "",
                          color: "primary",
                          label: `Retomar assinatura do ${_unref(data).plan_title}`
                        }, null, 8, ["onOnClick", "loading", "label"]))
                      : _createCommentVNode("", true),
                    (
                _unref(data).update_credit_card_enabled && item.key === 'credit_card'
              )
                      ? (_openBlock(), _createBlock(Button, {
                          key: 3,
                          onOnClick: handleCreditCards,
                          fullWidth: "",
                          outline: "",
                          label: "Alterar cartão de crédito"
                        }))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ])
            ]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              (_unref(error))
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("p", _hoisted_8, " Erro ao carregar plano: " + _toDisplayString(_unref(error)?.message), 1)
                  ]))
                : _createCommentVNode("", true)
            ], 64))
    ]),
    (_unref(data) && _unref(data).cancel_enabled)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _hoisted_12,
            _createElementVNode("a", {
              href: "",
              onClick: _withModifiers(onCancel, ["prevent"]),
              class: "text-danger text-subtitle"
            }, " Cancelar assinatura ")
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_ModalComponent, {
      id: "cancel_subs",
      title: "Cancelar assinatura e perder acesso ao Psiapp?"
    }, {
      body: _withCtx(() => [
        _hoisted_13,
        _hoisted_14
      ]),
      footer: _withCtx(() => [
        _createVNode(Button, {
          outline: "",
          onClick: onCancel,
          label: "Não, voltar"
        }),
        _createVNode(Button, {
          loading: _unref(canceling),
          color: "del",
          onClick: _unref(handleCancel),
          label: "Sim, cancelar assinatura"
        }, null, 8, ["loading", "onClick"])
      ]),
      _: 1
    })
  ]))
}
}

})